import { isProdLikeEnv } from '../../../system/service/CspConfigService';

export const useCanDebugAnalytics = (): boolean => !isProdLikeEnv();
